import PropTypes from 'prop-types';
import styled from 'helpers/styles';
import ComponentStyles from 'styles/mixins/Component.styles';
import Card from 'components/atoms/Cards/Card/Card';

const StyledConversationCard = styled(Card)`
  display: flex;
  flex-direction: row;
  gap: ${props => props.theme.layout('1sp')};
  background-color: transparent;
  border-radius: 0;
  
  &.ConversationCard {
    &-role {
      &-system {
        align-self: flex-start;

        > *:first-child {
          border-top-left-radius: 0;
        }
      }

      &-user {
        align-self: flex-end;
        flex-direction: row-reverse;

        > *:first-child {
          border-top-right-radius: 0;
        }
      }
    }
  }
  
  .ConversationCard {
    &-content {
      display: flex;
      flex-direction: column;
      gap: ${props => props.theme.layout('1sp')};
      border-radius: ${props => props.theme.radius(2)};
      background-color: ${props => props.theme.property('palette.primary.states.selected')};
      padding: ${props => props.theme.spacing(1.25)} ${props => props.theme.spacing(2)};

      .MuiInputBase-root {
        background-color: ${props => props.theme.property('palette.background.paper')};
      }
    }
    
    &-info {
      + .ConversationCard-progress {
        margin-top: ${props => props.theme.layout('-0.5sp')};
      }
    }
    
    &-actions {
      min-width: ${props => props.theme.layout('5sp')};
    }
  }
  
  &.ConversationCard-action {
    .ConversationCard {
      &-content {
        width: 100%;
        
        .ActionCard {
          border: unset;
          padding: ${props => props.theme.spacing(0.25)} 0;
        }

        .ConversationCard-actions {
          display: flex;
          flex-direction: column;
          gap: ${props => props.theme.layout('1sp')};
          
          &-footer {
            display: flex;
            justify-content: space-between;

            &-left, &-right {
              display: flex;
              gap: ${props => props.theme.layout('0.5sp')};

              .IconButton {
                background-color: ${props => props.theme.property('palette.background.paper')};
              }
            }
          }
        }
      }
    }
  }
  
  ${ComponentStyles}
`;

StyledConversationCard.propTypes = {
  theme: PropTypes.object
};

export default StyledConversationCard;
